import { motion, useReducedMotion } from "framer-motion";

// Scroll-reveal wrapper: subtle fade + slide-in. Respects reduced motion.
export const Reveal = ({
  children,
  as = "div",
  delay = 0,
  y = 18,
  x = 0,
  className = "",
  amount = 0.2,
  ...rest
}) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;

  const initial = reduce
    ? { opacity: 0 }
    : { opacity: 0, y, x };
  const animate = reduce
    ? { opacity: 1 }
    : { opacity: 1, y: 0, x: 0 };

  return (
    <MotionTag
      className={className}
      initial={initial}
      whileInView={animate}
      viewport={{ once: true, amount }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

// Staggered container + item helpers
export const StaggerGroup = ({ children, className = "", amount = 0.15, stagger = 0.08 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount }}
      variants={{
        hidden: {},
        show: {
          transition: { staggerChildren: reduce ? 0 : stagger },
        },
      }}
    >
      {children}
    </motion.div>
  );
};

export const StaggerItem = ({ children, className = "", y = 20 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      variants={{
        hidden: reduce ? { opacity: 0 } : { opacity: 0, y },
        show: {
          opacity: 1,
          y: 0,
          transition: { duration: 0.55, ease: [0.16, 1, 0.3, 1] },
        },
      }}
    >
      {children}
    </motion.div>
  );
};
